export * from './FindMarcaUseCase'
export * from './SaveMarcaUseCase'
export * from './adapter'
